import { Alert, AlertTitle, Button, Typography } from '@mui/material';
import { andJoin } from '~/utils/visitsHelper';

interface Props {
  patient: { firstName: string, lastName: string };
  careTeamProviders: { firstName: string, lastName: string }[];
  applyCareTeam: () => void;
}

export const CareTeamWarning: React.FC<Props> = ({
  patient,
  careTeamProviders,
  applyCareTeam
}) => {
  const providersNames = andJoin(careTeamProviders?.map((p: {firstName: string; lastName: string}) => {
    return `${p?.firstName} ${p?.lastName}`;
  }));

  return (
    <Alert severity="warning" sx={{ mb: 2, mt:2, p: 2, fontSize: '0.875rem' }}>
      <AlertTitle sx={{ fontSize: '0.875rem', mb: 0, lineHeight: 1 }}>Care Team Warning</AlertTitle>
      <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
        {patient?.firstName} {patient?.lastName?.split(' ')[0]}'s care team is {providersNames}.
        <Button
          onClick={applyCareTeam}
          variant="text"
          sx={{ ml: 0.75, fontSize: '0.75rem', lineHeight: 1 }}
          size="small"
        >
          Apply care team
        </Button>
      </Typography>
    </Alert>
  );
};
